// 🔧 about.js
// ✅ Purpose: Public trust page explaining Let's Go Vote
// ✅ Features:
// - SEO Helmet metadata
// - Explains what Let's Go Vote does
// - Builds trust with organizers
// - Links to solutions and request event page

import React from "react";
import { Link } from "react-router-dom";
import SeoHead from "../../components/seo_head";
import { PUBLIC_PAGE_SEO } from "../../constants/marketing_pages";

const About = () => {
  return (
    <>
      <SeoHead {...PUBLIC_PAGE_SEO.about} />

      <section id="top-content" className="container-fluid py-5">
        <div className="container">
          <div className="row mb-5">
            <div className="col-lg-8 text-start">
              <div className="text-uppercase text-primary fw-bold mb-2">
                About Let's Go Vote
              </div>

              <h1 className="display-4 fw-bold mb-3">
                Built for real-world community events
              </h1>

              <p className="lead text-muted">
                Let's Go Vote helps event organizers run QR-code voting,
                public choice awards, judged competitions, silent auctions,
                volunteer coordination, and sponsor visibility from one platform.
              </p>

              <Link to="/request_event" className="btn btn-primary btn-lg">
                Request Your Event
              </Link>
            </div>
          </div>

          <div className="white-section p-4 rounded shadow-sm bg-white mb-4 text-start">
            <h2 className="h3 mb-3">Why we built it</h2>

            <p>
              Many community events still rely on paper ballots, manual counting,
              spreadsheets, or disconnected tools. Let's Go Vote was created to
              make event participation easier for guests and easier to manage for
              organizers.
            </p>

            <p className="mb-0">
              The platform started with event voting needs and has grown into a
              broader event toolkit that supports entries, QR codes, voting,
              results, volunteers, sponsors, and silent auctions.
            </p>
          </div>

          <div className="white-section p-4 rounded shadow-sm bg-white mb-4">
            <h2 className="h3 mb-3 text-start">What we support</h2>

            <div className="row g-3">
              {[
                { title: "QR Code Voting", path: "/qr-code-voting" },
                { title: "People's Choice Voting", path: "/peoples-choice-voting" },
                { title: "Ranked Choice Voting", path: "/ranked-choice-voting" },
                { title: "Judged Scorecards", path: "/judged-scorecards" },
                { title: "Volunteer Management", path: "/volunteer-management" },
                { title: "Sponsor Management", path: "/sponsor-management" },
              ].map((item) => (
                <div className="col-md-6 col-lg-4" key={item.path}>
                  <Link
                    to={item.path}
                    className="border rounded p-3 h-100 d-block text-decoration-none"
                  >
                    {item.title}
                  </Link>
                </div>
              ))}
            </div>
          </div>

          <div className="alert alert-info text-start">
            <strong>Want to use Let's Go Vote for your event?</strong>
            <br />
            Submit an event request and we’ll help choose the right setup.

            <div className="mt-3">
              <Link to="/request_event" className="btn btn-primary">
                Request Your Event
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
